import { numberWithCommas } from 'utils'
import QRCode from 'react-qr-code'
import Barcode from 'react-barcode'
import { Col, Row } from 'antd'
import { dynamicFontText } from 'helpers'

function InDon({security,dataDetail}) {
    const getFontSize = (text_first: string, text_2nd: string) => {
        const f1 = dynamicFontText(text_first);
        const f2 = dynamicFontText(text_2nd);
        const p = Math.min(f1, f2);
        return p + "%"
    }
    const getPhone = (str) => {
        if(security){
            let a = '';
            for (let i=0;i<str.length;i++){
                if(i > 2 && i < 6){
                    a += '*';
                }else{
                    a += str[i];
                }
            }
            return a;
        }
        return str;
    }
    const getAddress = (str) => {
        if(security){
            return '***';
        }
        return str;
    }
    return (
        <Row>
            {dataDetail?.map((item) => (
                <>
                    <Col span={24} key={item?.order_code}>
                        <section className='sheet'>
                            <table style={{ paddingBottom: '3px', display: 'block' }}>
                                <tbody>
                                    <tr style={{ verticalAlign: 'top' }}>
                                        <td className='box-qr'>
                                            <QRCode value={item?.order_code || ''} />
                                            <div style={{ textAlign: 'center' }}><span style={{ fontWeight: 'bold', fontSize: '16px' }}>{item?.return_first_sort_code}</span></div>
                                        </td>
                                        <td>
                                            <div className='box-barcode'>
                                                <div><strong>SPX.VN</strong></div>
                                                <Barcode value={item?.order_code || ''} width={2} height={90} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className='border-top'>
                                <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '0px', fontSize: "32px" }}>
                                    <span style={{
                                        fontWeight: 'bold',
                                        fontSize: getFontSize(item?.r_first_sort_code, item?.r_third_sort_code),
                                        paddingTop: '3px',
                                        flex: "0 0 50%",
                                        textAlign: "right",
                                        paddingRight: "10px",
                                        whiteSpace: "nowrap"
                                    }}>
                                        {item?.r_first_sort_code}
                                    </span>
                                    <span style={{
                                        fontWeight: 'bold',
                                        fontSize: getFontSize(item?.r_first_sort_code, item?.r_third_sort_code),
                                        paddingTop: '3px',
                                        borderLeft: '1px dotted black',
                                        flex: "0 0 50%",
                                        textAlign: "left",
                                        paddingLeft: "10px",
                                        whiteSpace: "nowrap"
                                    }}>
                                        {item?.r_third_sort_code}
                                    </span>
                                </p>
                            </div>
                            <div className='border-top'>
                                <p style={{ paddingTop: 5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <span>
                                        Ngày tạo: <b>{item?.created_at}</b>
                                    </span>
                                    <span style={{ fontWeight: 'bold', fontSize: '30px', marginLeft: '20px', paddingTop: '3px' }}>
                                        {item?.order_code ?? ''}
                                    </span>
                                </p>
                            </div>
                            <div className='border-top main-content'>
                                <p style={{ fontWeight: 'bold', fontSize: '18px' }}>NGƯỜI NHẬN HÀNG:</p>
                                <p>
                                    Tên đại diện: <b style={{ fontSize: '15px' }}>{item?.receiver?.full_name ?? ''}</b>
                                </p>
                                <p>
                                    Số điện thoại: <b style={{ fontSize: '15px' }}>{getPhone(item?.receiver?.phone_number)}</b>
                                </p>
                                <p style={{ marginBottom: "5px" }}>
                                    Địa chỉ:{' '}
                                    <b style={{ fontSize: '15px' }}>
                                        {getAddress(item?.receiver?.address)}, {item?.receiver?.ward?.title}, {item?.receiver?.district?.title},{' '}
                                        {item?.receiver?.province?.title}
                                    </b>
                                </p>
                            </div>
                            <div className='border-top'>
                                <p style={{ fontWeight: 'bold', marginTop: '10px' }}>NGƯỜI GỬI:</p>
                                <p>
                                    Tên đại diện: <b>{item?.sender?.full_name ?? ''}</b>
                                </p>
                                <p>
                                    Số điện thoại: <b>{getPhone(item?.sender?.phone_number)}</b>
                                </p>
                                <p style={{ marginBottom: "5px" }}>
                                    Địa chỉ:{' '}
                                    <b style={{ fontSize: '15px' }}>
                                        {getAddress(item?.sender?.address)}, {item?.sender?.ward?.title}, {item?.sender?.district?.title},{' '}
                                        {item?.sender?.province?.title}
                                    </b>
                                </p>
                            </div>
                            <div className='border-top'>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <p style={{ fontWeight: 'bold', fontSize: '18px', marginTop: '6px' }}>GHI CHÚ:</p>
                                    <strong style={{ marginBottom: '5px', marginTop: '2px' }}>
                                        KL: {item?.detail?.package?.weight}Kg
                                    </strong>
                                </div>
                                <p>Sản phẩm: {item?.detail?.title ?? ''}</p>
                                <p>Shop: {item?.detail?.view_product === 1 ? 'cho khách xem hàng' : 'không được xem hàng'}</p>
                                <p>Gặp sự cố liên hệ người gửi: {item?.sender?.phone_number}</p>
                                <p style={{ marginTop: '5px', fontSize: '30px' }}>
                                    Tiền thu hộ: <b>{numberWithCommas(item?.cod)}</b>đ
                                </p>
                            </div>
                        </section>
                    </Col>
                    <div style={{ pageBreakAfter: 'always' }}></div></>
            ))}
        </Row>
    )
}

export default InDon
